module.exports = __webpack_public_path__ + "static/media/decode.7b97bcc4.svg";